import {
  ActionCreatorWithPayload,
  createAction,
  createSlice,
} from "@reduxjs/toolkit";

import listFactory from "../../../store/listFactory";

import type { UUID } from "../../../utils";
import type { ObjectWithId } from "../../../utils/ObjectWithId";
import type { GetBanksParams } from "../api/Banks";
import type { Bank } from "../models/Bank";

// TODO
// Move to appSlice.ts in the future
export interface UpdateActionPayload<T> {
  id: string;
  data: T;
  redirectOnSuccess?: boolean;
  resolve?: any;
  reject?: any;
}

export type UpdateAction<T> = ActionCreatorWithPayload<
  UpdateActionPayload<T>,
  string
>;

const { slicePart, selectors } = listFactory<Bank>("banks");

const initialState = {
  ...slicePart.initialState,
};

export const slice = createSlice({
  ...slicePart,
  initialState,
  reducers: {
    ...slicePart.reducers,
    setList: slicePart.reducers.setList,
    setItem: slicePart.reducers.setItem,
    setPaginatedList: slicePart.reducers.setPaginatedList,
    updateItem: slicePart.reducers.updateItem,
  },
});

export const {
  setList,
  setItem,
  setPaginatedList,
  updateItem,
  removeList,
} = slice.actions;

export const fetchBanks = createAction<Partial<GetBanksParams>>("fetchBanks");
export const fetchBank = createAction<ObjectWithId, "fetchBank">("fetchBank");
export const setBankActiveFlag = createAction<{ id: UUID; value: boolean }>(
  "setBankActiveFlag"
);
export const setBankBetaFlag = createAction<{ id: UUID; value: boolean }>(
  "setBankBetaFlag"
);
export const toggleVoltInstantPaymentsFlag = createAction<{
  id: UUID;
  value: boolean;
}>("togglevoltInstantPaymentsFlag");

export const updateBank = createAction<UpdateActionPayload<Bank>>("updateBank");

export const {
  selectList: selectBanks,
  selectItem: selectBank,
  selectPaginatedList: selectPaginatedBanks,
} = selectors;

export const banksOperationPath = {
  voltInstantPayments: (bankId: UUID | undefined) => [
    "banks",
    "items",
    bankId,
    "verifiedByVoltInstant",
  ],
};

export default slice.reducer;
